var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 5 4.5 2 2 5M14 11l-2.5 3L9 11M4.487 14V2M11.513 2v12","stroke":"var(--v-grey-darken-1)","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }